const translations = {
  "activity.header.pre-title": "Activity",
  "activity.header.roundup.title": "Save Money and Do Good!",
  "activity.header.subscription.title": "Save Money and Support Student Athletes!",
  "activity.header.whitelabel.title": "Save Money and Do Good!",
  "activity.header.how-it-works": "How it works",
  "activity.header.contributions.label": "Total cleared this month",
  "activity.header.no-cards.title": "You don't have transactions",
  "activity.header.no-cards.subtitle": "Subscribe to start",

  "activity.dashboard.activity-by-day.title": "Activity by day",
  "activity.dashboard.activity-by-day.legend.contribution": "Contribution",
  "activity.dashboard.cashback": "Cash Back",
  "activity.dashboard.current-balance.title": "Current Balance",
  "activity.dashboard.current-balance.subtitle": "It's your turn to get back.",
  "activity.dashboard.lifetime-balance": "Lifetime Balance",
  "activity.dashboard.button.withdraw": "Withdraw",
  "activity.dashboard.button.withdraw.subtitle.earn": "Earn",
  "activity.dashboard.button.withdraw.subtitle.earn.ending": "and withdraw your Cash Back",
  "activity.dashboard.button.withdraw.notice": "The credit will be applied to your next main card statement.",
  "activity.dashboard.button.withdraw.disabled.charges": "Please contact customer support so we can successfully process your membership dues before we release your cashback.",

  "activity.dashboard.select-card.subtitle": "Present Balance",
  "activity.dashboard.select-card.title": "Where do you want to transfer your rewards to?",

  "activity.dashboard.call-to-action.title": "Boost your Cash Back",
  "activity.dashboard.call-to-action.text": "Get more perks that reward your spending.",
  "activity.dashboard.call-to-action.link": "See offers",
  "activity.dashboard.monthly-contribution.title.roundup": "{month} Contribution",
  "activity.dashboard.monthly-contribution.subtitle": "Your contribution makes a big impact",
  "activity.modal.withdraw.amount": "Transfer",
  "activity.modal.card-type-to-my": "to my ",
  "activity.modal.credit-card": " credit card",
  "activity.modal.card.last4": "ending ",
  "activity.modal.congratulations.title": "Congratulations",
  "activity.modal.congratulations.subtitle": "You have redeemed your balance. Keep taking the best of your subscription",
  "activity.modal.congratulations.invite": "Invite your friends and boost your reward balance",

  // Dashboard - Donations
  "activity.dashboard.donations-by-day.title": "Donations by day",
  "activity.dashboard.donations-by-month.title": "Donations by month",
  "activity.dashboard.donations-by-month.btn": "See all",
  "activity.dashboard.donations-by-month.no-data": "Donation period has not ended yet",
  "activity.dashboard.donations-by-month.modal.date": "Credited date",
  "activity.dashboard.donations-by-month.modal.card": "Card ** {digits}",
  "activity.dashboard.donations-by-month.modal.total": "Total",
  // Dashboard - Cards
  "activity.dashboard.cards.last-digits": "Credit card ending in ***{lastDigits}",
  "activity.dashboard.cards.btn": "Edit card",
  "activity.dashboard.card-chip.default": "Default",
  "activity.dashboard.card-chip.paused": "Paused",
  "activity.dashboard.card-chip.deleted": "Deleted",
  //
  "activity.info-contributions.label": "Minimum monthly charge of {amount} applies",
  "activity.info-contributions.tooltip": "The minimum {amount} charge helps us get you the best possible deals",
  "activity.transactions.header.title": "Activity",
  "activity.transactions.no-data.title": "No transactions",
  "activity.transactions.no-data.subtitle": "You haven't made any transactions yet",
  "activity.transactions.headers.date": "Date",
  "activity.transactions.headers.card": "Card",
  "activity.transactions.headers.amount": "Amount",
  "activity.transactions.headers.roundUp": "Round Up",
  "activity.transactions.headers.contribution": "Contribution",
  "activity.transactions.headers.reward": "Reward",
  "activity.transactions.filters.cards.all-cards": "All cards",
  "activity.transactions.filters.cards.card": "Card ending {lastDigits}",
  "activity.transactions.disclaimer": "All purchase dates are converted to the UTC time zone. You might notice some discrepancies when comparing dates on your card statement.",
  // How it works
  "activity.how-it-works.title": "How it works",
  "activity.how-it-works.subtitle": "Don't miss out on this opportunity to give back while treating yourself!",
  "activity.roundup.how-it-works.card-1.title": "Link your card",
  "activity.roundup.how-it-works.card-1.subtitle": "Securely link your credit card and start to doing good and save money.",
  "activity.roundup.how-it-works.card-2.title": "Save money",
  "activity.roundup.how-it-works.card-2.subtitle": "Get instant access to incredible discounts from hundreds of popular brands.",
  "activity.roundup.how-it-works.card-3.title": "Donate your change",
  "activity.roundup.how-it-works.card-3.subtitle": "Each time you make a purchase, we'll round up the total to the nearest dollar.",
  "activity.subscription.how-it-works.card-1.title": "Link your card",
  "activity.subscription.how-it-works.card-1.subtitle": "Select your membership tier and link your credit card.",
  "activity.subscription.how-it-works.card-2.title": "Earn Rewards",
  "activity.subscription.how-it-works.card-2.subtitle": "Get access to exclusive Perks & Rewards.",
  "activity.subscription.how-it-works.card-3.title": "Make a difference",
  "activity.subscription.how-it-works.card-3.subtitle": "Support our current student-athletes and help us attract the best in the country.",
  "activity.whitelabel.how-it-works.card-1.title": "Link your card",
  "activity.whitelabel.how-it-works.card-1.subtitle": "Securely link your credit card and start to doing good and save money.",
  "activity.whitelabel.how-it-works.card-2.title": "Save money",
  "activity.whitelabel.how-it-works.card-2.subtitle": "Get instant access to incredible discounts from hundreds of popular brands.",
  "activity.whitelabel.how-it-works.card-3.title": "Donate your change",
  "activity.whitelabel.how-it-works.card-3.subtitle": "Each time you make a purchase, we'll round up the total to the nearest dollar.",
  "activity.how-it-works.title-2": "At the end of the month, we'll donate the rounded-up amount",
  "activity.how-it-works.subtitle-2": "It's as simple as that! Give effortlessly and get rewarded - it's a win-win.",
  "activity.how-it-works.where.title": "Where does my money go?",
};

export default translations;
